import * as types from './constants'

const initialState = {
    waiting: false,
    userId: null,
    error: null,
    isRegistrationDone: false,
    token: null,

    profile: {
        image: '/images/user.jpg',
        fullName: 'در حال بارگذاری',
        PlanCount: 0,
        RegistrationDate: new Date(),
        rankCurrentMonth: null,
        rankTotal: null,
    },
    planProfile: {
        image: '/images/user.jpg',
        fullName: 'در حال بارگذاری',
        PlanCount: 0,
        RegistrationDate: new Date(),
        rankCurrentMonth: null,
        rankTotal: null,
    },
    profileLoading: false,
    planProfileLoading: false,
    profileError: null,

    uploading: false,
    uploadingError: false,
}

const reducer = (state = initialState, actions) => {
    switch (actions.type) {
        case types.REGISTERATION_START:
            return {
                ...state,
                waiting: true,
            }
        case types.REGISTERATION_DUPLICATE:
            return {
                ...state,
                waiting: false,
                duplicateMessage: actions.payload,
            }
        case types.REGISTERATION_SUCCESS:
            return {
                ...state,
                isRegistrationDone: actions.isRegistrationDone,
                waiting: false,
            }
        case types.REGISTERATION_FAIL:
            return {
                ...state,
                error: actions.error,
                waiting: false,
            }
        case types.VALIDATION_START:
            return {
                ...state,
                waiting: true,
            }
        case types.VALIDATION_SUCCESS:
            return {
                ...state,
                token: actions.payload,
                waiting: false,
            }
        case types.VALIDATION_FAIL:
            return {
                ...state,
                error: actions.error,
                waiting: false,
            }
        case types.GET_PROFILE_START:
            return {
                ...state,
                profileLoading: true,
                profileError: null,
            }
        case types.GET_PROFILE_SUCCESS:
            return {
                ...state,
                profile: actions.payload,
                profileLoading: false,
            }
        case types.GET_PROFILE_FAIL:
            return {
                ...state,
                profileError: actions.error,
                profileLoading: false,
            }
        case types.GET_PLAN_PROFILE_START:
            return {
                ...state,
                planProfileLoading: true,
                profileError: null,
            }
        case types.GET_PLAN_PROFILE_SUCCESS:
            return {
                ...state,
                planProfile: actions.payload,
                planProfileLoading: false,
            }
        case types.GET_PLAN_PROFILE_FAIL:
            return {
                ...state,
                profileError: actions.error,
                planProfileLoading: false,
                // TODO: TEMP
                // planProfile: null,
            }
        case types.UPLOAD_PROFILE_START:
            return {
                ...state,
                uploading: true,
                uploadingError: null,
            }
        case types.UPLOAD_PROFILE_SUCCESS:
            return {
                ...state,
                uploading: false,
                uploadingError: null,
            }
        case types.UPLOAD_PROFILE_FAIL:
            return {
                ...state,
                uploading: false,
                uploadingError: actions.payload,
            }
        case types.UPLOAD_PLAN_START:
            return {
                ...state,
                uploading: true,
                uploadingError: null,
            }
        case types.UPLOAD_PLAN_SUCCESS:
            return {
                ...state,
                uploading: false,
                uploadingError: null,
            }
        case types.UPLOAD_PLAN_FAIL:
            return {
                ...state,
                uploading: false,
                uploadingError: actions.payload,
            }

        default:
            return state
    }
}

export default reducer
